import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function NCBISrrDropZone({ onFileSelected, disabled = false }) {
  const handleDrop = (acceptedFiles) => {
    if (!acceptedFiles?.length || disabled) {
      return;
    }

    onFileSelected?.(acceptedFiles[0]);
  };

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop: handleDrop,
    multiple: false,
    disabled,
    accept: {
      'text/plain': ['.txt']
    }
  });

  const style = useMemo(() => {
    const base = {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '20px',
      borderWidth: 2,
      borderRadius: 2,
      borderColor: '#eeeeee',
      borderStyle: 'dashed',
      backgroundColor: '#fafafa',
      color: '#bdbdbd',
      cursor: disabled ? 'not-allowed' : 'pointer',
      outline: 'none',
      transition: 'border .24s ease-in-out'
    };

    return {
      ...base,
      ...(isFocused ? { borderColor: '#2196f3' } : {}),
      ...(isDragAccept ? { borderColor: '#00e676' } : {}),
      ...(isDragReject ? { borderColor: '#ff1744' } : {}),
      ...(disabled ? { opacity: 0.6 } : {})
    };
  }, [disabled, isDragAccept, isDragReject, isFocused]);

  return (
    <Box {...getRootProps({ style })}>
      <input {...getInputProps()} />
      <Typography variant="h6" color="textPrimary" sx={{ mb: 1 }}>
        Upload NCBI SRR list
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Drag and drop a text file, or click to select one.
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        One SRR/ERR identifier per line (for example: SRR12345678).
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1, fontWeight: 600 }}>
        Only .txt files are accepted.
      </Typography>
    </Box>
  );
}

export default NCBISrrDropZone;
